"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _BrixelIcon = _interopRequireDefault(require("./BrixelIcon"));
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var _indexOf = _interopRequireDefault(require("lodash/indexOf"));
var _BrixelButtonSecondary = _interopRequireDefault(require("./BrixelButtonSecondary"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelTags = props => {
  const {
    className = null,
    input,
    label = 'Add new tag',
    readOnly = false
  } = props;
  const [addNew, setAddNew] = (0, _react.useState)(false);
  const [value, setValue] = (0, _react.useState)('');
  const [isError, setIsError] = (0, _react.useState)(false);
  const addNewBtn = e => {
    e.preventDefault();
    setAddNew(true);
    setValue('');
  };
  const saveTags = e => {
    e.preventDefault();
    const val = (0, _cloneDeep.default)(input.value) || [];
    if (value) {
      // Check for duplicate export tags
      if (value.includes('export-1') || value.includes('export-2') || value.includes('export-3') || value.includes('export-4') || value.includes('export-5') || value.includes('export-6') || value.includes('export-7') || value.includes('export-8') || value.includes('hero') || value.includes('page-location') || value.includes('page-explore') || value.includes('page-floorplan') || value.includes('page-tour') || value.includes('page-documents')) {
        if ((0, _indexOf.default)(val, value) !== -1) {
          setIsError(true);
          return;
        }
      }
      val.push(value);
      input.onChange(val);
    }
    setAddNew(false);
    setIsError(false);
    setValue('');
  };
  const removeEl = (e, id) => {
    e.preventDefault();
    const val = (0, _cloneDeep.default)(input.value);
    val.splice(id, 1);
    setAddNew(false);
    setValue('ss');
    input.onChange(val);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `brixel-tags ${className}`
  }, /*#__PURE__*/_react.default.createElement("ul", null, input.value && input.value.map((tag, i) => (/*#__PURE__*/_react.default.createElement("li", {
    className: `brixel-single-tag mb-1 ${readOnly ? 'readOnlyTags' : 'editableTags'}`,
    key: `ipt_${i.toString()}`
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "fsize-300 pr-small-4"
  }, tag), !readOnly && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    icon: "close-small",
    iconWidth: 'w-fix-16',
    saturationTxt: 600,
    saturation: 600,
    color: "text",
    onClick: e => removeEl(e, i)
  }))))), !readOnly && (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, addNew ? (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("li", {
    className: "brixel-input-tag"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "text",
    value: value,
    onChange: e => setValue(e.target.value),
    onBlur: e => saveTags(e),
    autoFocus: true,
    onKeyUp: e => e.key === 'Enter' ? saveTags(e) : ''
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "input-help"
  }, "Enter \u21B5"), value.length > 0 && (/*#__PURE__*/_react.default.createElement("span", {
    className: "input-help"
  }, "Enter \u21B5"))), isError && (/*#__PURE__*/_react.default.createElement("span", {
    className: "errorMsg fsize-200 txtRed400"
  }, "Duplicate export tag not allowed")))) : (/*#__PURE__*/_react.default.createElement("li", {
    className: "button-wrap"
  }, /*#__PURE__*/_react.default.createElement(_BrixelButtonSecondary.default, {
    label: label,
    onClick: e => addNewBtn(e),
    rightIcon: "plus",
    rounded: true,
    small: true
  })))))));
};
var _default = exports.default = BrixelTags;